import { Routes } from "@angular/router";
import { LandingComponent } from "./landing/landing.component";

export const appRoutes: Routes = [
  {
    path: "",
    component: LandingComponent,
    children: [
      {
        path: "view/:uuid",
        loadComponent: () =>
          import("./landing/landing-content/landing-content.component").then(
            (m) => m.LandingContentComponent,
          ),
      },
      {
        path: "view/:uuid/:domain",
        loadComponent: () =>
          import("./landing/landing-content/landing-content.component").then(
            (m) => m.LandingContentComponent,
          ),
      },
      {
        path: "view/:content_type/:uuid",
        loadComponent: () =>
          import("./landing/landing-content/landing-content.component").then(
            (m) => m.LandingContentComponent,
          ),
      },
      {
        path: "view/:content_type/:uuid/:domain",
        loadComponent: () =>
          import("./landing/landing-content/landing-content.component").then(
            (m) => m.LandingContentComponent,
          ),
      },
      {
        path: "jobs/:uuid",
        loadComponent: () =>
          import("./landing/landing-content/job-share-list-card/job-share-list-card.component").then(
            (m) => m.JobShareListCardComponent,
          ),
      },
      {
        path: "",
        loadComponent: () =>
          import("./landing/landing-content/landing-content.component").then(
            (m) => m.LandingContentComponent,
          ),
      },
    ],
  },
  { path: "**", redirectTo: "", pathMatch: "full" },
];
